import {
  Container,
  useTheme,
  Step,
  Box,
  Stack,
  Link,
  StepLabel,
  Typography,
  Stepper,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { useState, useEffect } from 'react';
import { FragmentComponent } from './fragments.component';

const steps = ['1', '2', '3'];

export const MobileCheckout = ({ chekoutProps, handleSubmit }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());

  useEffect(() => {
    const handleBackButton = (event) => {
      if (activeStep > 0) {
        event.preventDefault();
        handleBack();
      }
    };

    window.history.pushState({ step: activeStep }, '');
    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [activeStep]);

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const theme = useTheme();

  return (
    <Container
      sx={{
        margin: '2rem auto',
        display: { xs: 'flex', md: 'none', flexDirection: 'column' },
      }}
    >
      <Stack
        sx={{ margin: '1rem 2rem' }}
        flexDirection={'column'}
        justifyContent={'center'}
        spacing={2}
      >
        <Typography
          variant="h3"
          sx={{
            color: `${theme.palette.primary.main}`,
            textAlign: 'center',
          }}
        >
          Etapa {activeStep + 1} de 3
        </Typography>
        <Stepper activeStep={activeStep}>
          {steps.map((_, index) => (
            <Step key={index}>
              <StepLabel
                slots={{
                  stepIcon: () => (
                    <Box
                      sx={{
                        width: 24,
                        height: 24,
                        borderRadius: '50%',
                        backgroundColor:
                          activeStep >= index ? 'primary.main' : 'text.primary',
                        color:
                          activeStep >= index ? 'common.white' : 'text.primary',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.875rem',
                      }}
                    >
                      {index + 1}
                    </Box>
                  ),
                }}
              />
            </Step>
          ))}
        </Stepper>

        <Link
          to="/search-results"
          component={RouterLink}
          style={{
            textDecoration: 'underline',
            textDecorationColor: `${theme.palette.grey[100]}`,
          }}
        >
          <Typography
            variant="body1"
            sx={{ color: 'black', textAlign: 'center' }}
          >
            Voltar para a pesquisa anterior
          </Typography>
        </Link>
      </Stack>

      <form onSubmit={handleSubmit}>
        <FragmentComponent
          {...chekoutProps}
          activeStep={activeStep}
          handleNext={handleNext}
        />
      </form>
    </Container>
  );
};
